var map = {
	"./en/tournaments/14yearAnniversarySeries2024/leaderboardTabs.json": 83973,
	"./en/tournaments/15yearAnniversarySeries2025/leaderboardTabs.json": 23343,
	"./en/tournaments/moneyMakerTour2025/leaderboardTabs.json": 39859,
	"./en/tournaments/msptCanadianPokerChampionship2025/leaderboardTabs.json": 76686,
	"./en/tournaments/powerWeeksJune2025/leaderboardTabs.json": 66819,
	"./en/tournaments/springBreakPowerWeeks2025/leaderboardTabs.json": 2187,
	"./en/tournaments/springBreakPowerWeeks2026/leaderboardTabs.json": 14870,
	"./en/tournaments/worldCupOfCards2025/leaderboardTabs.json": 13645,
	"./en/tournaments/wptGlobalOctoberMillions2023/leaderboardTabs.json": 7380,
	"./en/tournaments/wptGlobalSummerMillion2025/leaderboardTabs.json": 91916,
	"./en/tournaments/wptGlobalWinterClassic2026/leaderboardTabs.json": 89973,
	"./en/tournaments/wptMontreal2024/leaderboardTabs.json": 56189,
	"./en/tournaments/wptPlaygroundOctober2024/leaderboardTabs.json": 88070,
	"./en/tournaments/wptWinterClassic2024/leaderboardTabs.json": 23682,
	"./en/tournaments/wsopcPlayground2024/leaderboardTabs.json": 29973,
	"./en/tournaments/wsopcPlaygroundAugust2024/leaderboardTabs.json": 42460,
	"./en/tournaments/wsopcPlaygroundSpring2025/leaderboardTabs.json": 52079,
	"./fr/tournaments/14yearAnniversarySeries2024/leaderboardTabs.json": 91370,
	"./fr/tournaments/15yearAnniversarySeries2025/leaderboardTabs.json": 60096,
	"./fr/tournaments/moneyMakerTour2025/leaderboardTabs.json": 9942,
	"./fr/tournaments/msptCanadianPokerChampionship2025/leaderboardTabs.json": 6141,
	"./fr/tournaments/powerWeeksJune2025/leaderboardTabs.json": 94750,
	"./fr/tournaments/springBreakPowerWeeks2025/leaderboardTabs.json": 74644,
	"./fr/tournaments/springBreakPowerWeeks2026/leaderboardTabs.json": 92077,
	"./fr/tournaments/worldCupOfCards2025/leaderboardTabs.json": 49434,
	"./fr/tournaments/wptGlobalOctoberMillions2023/leaderboardTabs.json": 36757,
	"./fr/tournaments/wptGlobalSummerMillion2025/leaderboardTabs.json": 58753,
	"./fr/tournaments/wptGlobalWinterClassic2026/leaderboardTabs.json": 37944,
	"./fr/tournaments/wptMontreal2024/leaderboardTabs.json": 64314,
	"./fr/tournaments/wptPlaygroundOctober2024/leaderboardTabs.json": 95087,
	"./fr/tournaments/wptWinterClassic2024/leaderboardTabs.json": 60119,
	"./fr/tournaments/wsopcPlayground2024/leaderboardTabs.json": 6306,
	"./fr/tournaments/wsopcPlaygroundAugust2024/leaderboardTabs.json": 31355,
	"./fr/tournaments/wsopcPlaygroundSpring2025/leaderboardTabs.json": 15940
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__.t(id, 3 | 16);
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 87738;
module.exports = webpackAsyncContext;